import { useRef, useState } from "react";
import {
	ExternalDropZone,
	Upload,
	UploadFileInfo,
} from "@progress/kendo-react-upload";
import { t } from "i18next";
import { IVesselDocument } from "interface/vessel";
import { useInfoStore } from "store/error";

export default function DocumentFileUpload({
	files,
	setFiles,
	disabled = false,
}: {
	files: UploadFileInfo[];
	setFiles: (files: UploadFileInfo[]) => void;
	disabled?: boolean;
}) {
	const uploadRef = useRef<Upload>(null);
	return (
		<div>
			<ExternalDropZone
				uploadRef={uploadRef}
				disabled={disabled}
				customHint={t("DragAndDropFileHereFile")}
				// customNote={t("DragAndDropFileHereOrClickToSelect")}
			/>
			<Upload
				ref={uploadRef}
				multiple={true}
				autoUpload={false}
				showActionButtons={false}
				disabled={disabled}
				files={files}
				selectMessageUI={(data) => {
					return <div>{t("SelectFile")}</div>;
				}}
				// listItemUI={(data) => {

				// }}
				// customHint="ffffk"

				onAdd={(event) => {
                    setFiles(event.newState);
				}}
				onRemove={(event) => {
					setFiles(event.newState);
				}}
			/>
		</div>
	);
}

export function openFile(
	document: IVesselDocument,
	view: boolean,
	setPreview: (data: { url: string; name: string; type: string }) => void,
) {
	try {
		if (!document.fileByte) throw new Error("Document content is missing.");
		// A .NET byte[] is serialized as Base64 in JSON. A TypeScript cast
		// cannot turn that string into a Blob; decode it to actual file bytes.
		const binary = atob(document.fileByte);
		const bytes = new Uint8Array(binary.length);
		for (let index = 0; index < binary.length; index++) {
			bytes[index] = binary.charCodeAt(index);
		}
		const blob = new Blob([bytes], {
			type: document.contentType || "application/octet-stream",
		});
		const url = URL.createObjectURL(blob);
		if (
			view &&
			[
				"application/pdf",
				"image/png",
				"image/jpeg",
				"image/gif",
				"image/webp",
				"text/plain",
			].includes(document.contentType || "")
		) {
			setPreview({ url, type: blob.type, name: document.fileName ?? "" });
            return true;
		} else {
			const link = window.document.createElement("a");
			link.href = url;
			link.download = document.fileName || "attachment";
			link.click();
			setTimeout(() => URL.revokeObjectURL(url), 60000);
            return false;
		}
	} catch {
		const { setInfo, resetStore } = useInfoStore.getState();
		setInfo({
			title: t("AttachmentDownloadError"),
			show: true,
			description: t("AttachmentDownloadError"),
			infoType: "Error",
			actions: [
				{
					text: t("OK"),
					btn: resetStore,
					disabled: false,
					bgColor: "",
					textColor: "",
				},
			],
		});
        return false;
	}
}
